import React, { useState } from "react";
import QuotationInput from "./QuotationInput";
import QuotationResult from "./QuotationResult";

interface Props {
  onClose?: () => void;
  open?: boolean;
}

const QuotationModal: React.FC<Props> = ({ onClose, open }) => {
  const [data, setData] = useState({
    address: "",
    electricBill: "",
    email: "",
    name: "",
    phone: "",
  });
  const [error, setError] = useState("");
  const [result, setResult] = useState({
    range: "",
    size: 0,
  });

  if (!open) {
    return null;
  }

  if (result.range) {
    return (
      <QuotationResult
        data={{ ...data, ...result }}
        onBack={() => setResult({ range: "", size: 0 })}
        onClose={onClose}
      />
    );
  }

  return (
    <QuotationInput
      data={data}
      error={error}
      onChange={setData}
      onError={setError}
      onClose={onClose}
      onSuccess={setResult}
    />
  );
};

export default QuotationModal;
